"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.default = firebaseConnect;

var _differenceWith2 = _interopRequireDefault(require("lodash/differenceWith")),
    _isEqual2 = _interopRequireDefault(require("lodash/isEqual")),
    _react = _interopRequireWildcard(require("react")),
    _propTypes = _interopRequireDefault(require("prop-types")),
    _hoistNonReactStatics = _interopRequireDefault(require("hoist-non-react-statics")),
    _query = require("./actions/query"),
    _utils = require("./utils"),
    _ReactReduxFirebaseContext = _interopRequireDefault(require("./ReactReduxFirebaseContext"));

function _getRequireWildcardCache() {
  if ("function" != typeof WeakMap) return null;
  var cache = new WeakMap();
  return _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  }, cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) return obj;
  if (null === obj || "object" !== _typeof(obj) && "function" != typeof obj) return {
    default: obj
  };

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) return cache.get(obj);
  var newObj = {},
      hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      desc && (desc.get || desc.set) ? Object.defineProperty(newObj, key, desc) : newObj[key] = obj[key];
    }
  }

  return newObj.default = obj, cache && cache.set(obj, newObj), newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function _extends() {
  return _extends = Object.assign || function (target) {
    for (var source, i = 1; i < arguments.length; i++) {
      for (var key in source = arguments[i], source) {
        Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
      }
    }

    return target;
  }, _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var source, i = 1; i < arguments.length; i++) {
    source = null == arguments[i] ? {} : arguments[i], i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

function _defineProperties(target, props) {
  for (var descriptor, i = 0; i < props.length; i++) {
    descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  return protoProps && _defineProperties(Constructor.prototype, protoProps), staticProps && _defineProperties(Constructor, staticProps), Constructor;
}

function _createSuper(Derived) {
  return function () {
    var result,
        Super = _getPrototypeOf(Derived);

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else result = Super.apply(this, arguments);

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  return call && ("object" === _typeof(call) || "function" == typeof call) ? call : _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (void 0 === self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return self;
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (e) {
    return !1;
  }
}

function _getPrototypeOf(o) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function (o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  }, _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if ("function" != typeof superClass && null !== superClass) throw new TypeError("Super expression must either be null or a function");
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: !0,
      configurable: !0
    }
  }), superClass && _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  return _setPrototypeOf = Object.setPrototypeOf || function (o, p) {
    return o.__proto__ = p, o;
  }, _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  return key in obj ? Object.defineProperty(obj, key, {
    value: value,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : obj[key] = value, obj;
}

function firebaseConnect() {
  var queriesConfig = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : [];
  return function (WrappedComponent) {
    function FirebaseConnectWithContext(props) {
      return _react.default.createElement(_ReactReduxFirebaseContext.default.Consumer, null, function (_internalFirebase) {
        return _react.default.createElement(FirebaseConnectWrapped, _extends({}, props, {
          dispatch: _internalFirebase.dispatch,
          firebase: _internalFirebase
        }));
      });
    }

    var FirebaseConnectWrapped = function (_Component) {
      function FirebaseConnectWrapped() {
        var _this;

        _classCallCheck(this, FirebaseConnectWrapped);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _this = _super.call.apply(_super, [this].concat(args)), _defineProperty(_assertThisInitialized(_this), "firebaseEvents", []), _defineProperty(_assertThisInitialized(_this), "firebase", null), _defineProperty(_assertThisInitialized(_this), "prevData", null), _this;
      }

      _inherits(FirebaseConnectWrapped, _Component);

      var _super = _createSuper(FirebaseConnectWrapped);

      return _createClass(FirebaseConnectWrapped, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          var _this$props = this.props,
              firebase = _this$props.firebase,
              dispatch = _this$props.dispatch,
              inputAsFunc = (0, _utils.createCallable)(queriesConfig);
          this.prevData = inputAsFunc(this.props, this.props);
          var ref = firebase.ref,
              helpers = firebase.helpers,
              storage = firebase.storage,
              database = firebase.database,
              auth = firebase.auth;
          this.firebase = _objectSpread({
            ref: ref,
            storage: storage,
            database: database,
            auth: auth
          }, helpers), this._firebaseEvents = (0, _utils.getEventsFromInput)(this.prevData), (0, _query.watchEvents)(firebase, dispatch, this._firebaseEvents);
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          var _this$props2 = this.props,
              firebase = _this$props2.firebase,
              dispatch = _this$props2.dispatch;
          (0, _query.unWatchEvents)(firebase, dispatch, this._firebaseEvents);
        }
      }, {
        key: "UNSAFE_componentWillReceiveProps",
        value: function UNSAFE_componentWillReceiveProps(np) {
          var _this$props3 = this.props,
              firebase = _this$props3.firebase,
              dispatch = _this$props3.dispatch,
              inputAsFunc = (0, _utils.createCallable)(queriesConfig),
              data = inputAsFunc(np, this.store);

          if (!(0, _isEqual2.default)(data, this.prevData)) {
            var itemsToSubscribe = (0, _differenceWith2.default)(data, this.prevData, _isEqual2.default),
                itemsToUnsubscribe = (0, _differenceWith2.default)(this.prevData, data, _isEqual2.default);
            this.prevData = data, (0, _query.unWatchEvents)(firebase, dispatch, (0, _utils.getEventsFromInput)(itemsToUnsubscribe)), this._firebaseEvents = (0, _utils.getEventsFromInput)(data), (0, _query.watchEvents)(firebase, dispatch, (0, _utils.getEventsFromInput)(itemsToSubscribe));
          }
        }
      }, {
        key: "render",
        value: function render() {
          return _react.default.createElement(WrappedComponent, this.props);
        }
      }]), FirebaseConnectWrapped;
    }(_react.Component);

    return _defineProperty(FirebaseConnectWrapped, "displayName", (0, _utils.wrapDisplayName)(WrappedComponent, "FirebaseConnectWrapped")), _defineProperty(FirebaseConnectWrapped, "wrappedComponent", WrappedComponent), FirebaseConnectWrapped.propTypes = {
      dispatch: _propTypes.default.func.isRequired,
      firebase: _propTypes.default.object.isRequired
    }, FirebaseConnectWithContext.displayName = (0, _utils.wrapDisplayName)(WrappedComponent, "FirebaseConnect"), FirebaseConnectWithContext.wrappedComponent = WrappedComponent, (0, _hoistNonReactStatics.default)(FirebaseConnectWithContext, WrappedComponent);
  };
}

module.exports = exports.default;